'use strict';

import vxcookies from '@vstx/vxcookies'; // internal lib -> https://github.com/Campoint/vxcookies

const Constants = {
	ActionTypes: {
		Blog: {
			WP_BLOG_POSTS_FETCH: 'VXONE_WP_BLOG_POSTS_FETCH',
			WP_BLOG_POSTS_RECEIVED: 'VXONE_WP_BLOG_POSTS_RECEIVED',
			PM_FETCH: 'VXONE_MOBILE_BLOG_POSTS_FETCH',
			PM_RECEIVED: 'VXONE_MOBILE_BLOG_POSTS_RECEIVED',
			ARCHIVES_FETCH: 'VXONE_MOBILE_BLOG_ARCHIVES_FETCH',
			ARCHIVES_RECEIVED: 'VXONE_MOBILE_BLOG_ARCHIVES_RECEIVED',
			ARCHIVES_PM_FETCH: 'VXONE_MOBILE_BLOG_ARCHIVES_PM_FETCH',
			ARCHIVES_PM_RECEIVED: 'VXONE_MOBILE_BLOG_ARCHIVES_PM_RECEIVED',
		},

		Messenger: {
			SELECT_CHANNEL: 'MESSENGER_SELECT_CHANNEL',
			UNSELECT_CHANNEL: 'MESSENGER_UNSELECT_CHANNEL',
			FILTER_ONLINE_CHANNELS: 'MESSENGER_FILTER_ONLINE_CHANNELS',
			ADD_GIFT_TO_MESSAGE: 'MESSENGER_ADD_GIFT_TO_MESSAGE',
			REMOVE_GIFT_FROM_MESSAGE: 'MESSENGER_REMOVE_GIFT_FROM_MESSAGE',
			UPDATE_RECOMMENDED_ACTORS: 'MESSENGER_UPDATE_RECOMMENDED_ACTORS',
			UPDATE_RECOMMENDED_ACTORS_GRID: 'MESSENGER_UPDATE_RECOMMENDED_ACTORS_GRID',
			SET_ALL_MESSAGES_READ: 'MESSENGER_SET_ALL_MESSAGES_READ',
			SET_RESTORE_PREVIOUS_URL: 'MESSENGER_SET_RESTORE_PREVIOUS_URL',
			SET_UNREAD_MESSAGES_COUNT: 'MESSENGER_UNREAD_MESSAGES_COUNT',
			SET_IS_CHAT_EXIT_OPEN: 'MESSENGER_SET_IS_CHAT_EXIT_OPEN',
			BUY_CHAT_TICKET: 'MESSENGER_BUY_CHAT_TICKET',
			REMOVE_CHAT_TICKET: 'MESSENGER_REMOVE_CHAT_TICKET',
		},

		Notification: {
			SEND_MESSAGE: 'NOTIFICATION_SEND_MESSAGE',
			SET_ALL_CHANNELS_SEEN: 'NOTIFICATION_SET_ALL_CHANNELS_SEEN',
			CAN_ONECLICK: 'GUEST_CAN_ONECLICK',
			CHARGE_ONECLICK: 'GUEST_CHARGE_ONECLICK',
			LOAD_MORE_CHANNELS: 'NOTIFICATION_LOAD_MORE_CHANNELS',
			LOAD_ONLINE_CHANNELS: 'NOTIFICATION_LOAD_ONLINE_CHANNELS',
			FILTER_CHANNELS: 'NOTIFICATION_FILTER_CHANNELS',
			ARCHIVE_CHANNEL: 'NOTIFICATION_ARCHIVE_CHANNEL',
			MARK_NAVBAR_NOTIFICATION_AS_READ: 'NOTIFICATION_MARK_NAVBAR_NOTIFICATION_AS_READ',
			MARK_NAVBAR_NOTIFICATION_AS_SEEN: 'NOTIFICATION_MARK_NAVBAR_NOTIFICATION_AS_SEEN',
			MARK_FLOATING_NOTIFICATION_AS_READ: 'NOTIFICATION_MARK_FLOATING_NOTIFICATION_AS_READ',
			REFRESH_EMAIL_PROPERTIES: 'NOTIFICATION_REFRESH_EMAIL_PROPERTIES',
			PASSWORD_CHANGED: 'NOTIFICATION_PASSWORD_CHANGED',
			SEND_SIGNUP_EMAIL: 'NOTIFICATION_SEND_SIGNUP_EMAIL',
			FAVORITE_PIN_ACTOR: 'NOTIFICATION_FAVORITE_PIN_ACTOR',
			FAVORITE_UNPIN_ACTOR: 'NOTIFICATION_FAVORITE_UNPIN_ACTOR',
			FAVORITE_SET_PINNED_ACTOR_EMAIL_NOTIFICATION: 'NOTIFICATION_FAVORITE_SET_PINNED_ACTOR_EMAIL_NOTIFICATION',
			FAVORITE_SET_PINNED_ACTOR_SMS_NOTIFICATION: 'NOTIFICATION_FAVORITE_SET_PINNED_ACTOR_SMS_NOTIFICATION',
			FAVORITE_PIN_ALBUM: 'NOTIFICATION_FAVORITE_PIN_ALBUM',
			FAVORITE_UNPIN_ALBUM: 'NOTIFICATION_FAVORITE_UNPIN_ALBUM',
			FAVORITE_PIN_SEDCARDS: 'NOTIFICATION_FAVORITE_PIN_SEDCARDS',
			FAVORITE_PIN_PICTURE: 'NOTIFICATION_FAVORITE_PIN_PICTURE',
			FAVORITE_UNPIN_PICTURE: 'NOTIFICATION_FAVORITE_UNPIN_PICTURE',
			REMOVE_STATUS_BAR: 'NOTIFICATION_REMOVE_STATUS_BAR',
		},

		Actor: {
			LOAD_NOTE: 'ACTOR_LOAD_NOTE',
			LOAD_CHAT_RATINGS: 'ACTOR_CHAT_RATINGS',
			LOAD_INTERVIEWS: 'ACTOR_LOAD_INTERVIEWS',
			LOAD_RECOMMENDED_MODELS: 'ACTOR_LOAD_RECOMMENDED_MODELS',
		},

		Gallery: {
			GALLERY_SET_SEDCARDS_GUEST_RATING: 'GALLERY_SET_SEDCARDS_GUEST_RATING',
			SET_GUEST_RATING: 'GALLERY_SET_GUEST_RATING',
		},

		ProSearch: {
			CHANGE_SEARCH_CONDITION: 'PROSEARCH_CHANGE_SEARCH_CONDITION',
			LOAD_PAGE: 'PROSEARCH_LOAD_PAGE',
			DELETE_FILTER: 'PROSEARCH_DELETE_FILTER',
			SET_SEARCH_LOCATION_BY_ZIP: 'PROSEARCH_SET_SEARCH_LOCATION_BY_ZIP',
		},

		SearchResult: {
			SET_ACTOR_ONLINE_STATE: 'SEARCH_RESULT_SET_ACTOR_ONLINE_STATE',
			ACTOR_SEARCH: 'actors-search',
			MAGAZINE_SEARCH: 'magazine-search',
			VIDEOS_SEARCH: 'videos-search',
			SERIES_SEARCH: 'series-search',
		},

		Teaser: {
			OPEN_PAYTOUR: 'TEASER_OPEN_PAYTOUR',
			OPEN_PROMOCODE: 'TEASER_OPEN_PROMOCODE',
			OPEN_AVS: 'OPEN_AVS',
			OPEN_VIDEO: 'OPEN_VIDEO',
			OPEN_SIGNUP: 'TEASER_OPEN_SIGNUP',
			OPEN_VOICECALL: 'TEASER_OPEN_VOICECALL',
			OPEN_MODALBOX: 'TEASER_OPEN_MODALBOX',
		},

		TileGrid: {
			LOAD_GRID: 'TILE_GRID_LOAD_GRID',
			LOAD_VIDEO_ALBUM_PICTURES: 'LOAD_VIDEO_ALBUM_PICTURES',
			RESET_BACK_LINK: 'RESET_BACK_LINK',
			RESET_SCROLL_POSITION: 'RESET_SCROLL_POSITION',
			SET_BACK_LINK: 'SET_BACK_LINK',
			SET_RESTORE_SCROLL_POSITION: 'SET_RESTORE_SCROLL_POSITION',
			SET_SCROLL_POSITION: 'SET_SCROLL_POSITION',
			SET_TILE_GRID_KEY: 'SET_TILE_GRID_KEY',
			SET_TILE_GRID_MODE: 'SET_TILE_GRID_MODE',
		},

		VXPay: {
			REDIRECT_TO: 'VXPAY_REDIRECT_TO',
			SHOW_PAYTOUR: 'VXPAY_SHOW_PAYTOUR',
		},
	},

	ApiTypes: {
		Notification: {
			Outgoing: {
				REQUEST_SESSION: 'requestSession',
				SEND_MESSAGE: 'sendMessage',
				SET_ALL_CHANNELS_SEEN: 'allChannelsSeen',
				CAN_ONECLICK: 'canOneClick',
				CHARGE_ONECLICK: 'chargeOneClick',
				LOAD_CHANNELS: 'loadChannels',
				LOAD_ONLINE_CHANNELS: 'loadOnlineChannels',
				FILTER_CHANNELS: 'filterChannels',
				ARCHIVE_CHANNEL: 'archiveChannel',
				MARK_NAVBAR_NOTIFICATION_AS_READ: 'navbarNotificationMarkAsRead',
				MARK_NAVBAR_NOTIFICATION_AS_SEEN: 'navbarNotificationMarkAsSeen',
				REQUEST_NAVBAR_NOTIFICATIONS: 'navbarNotificationsRequestNotifications',
				MARK_FLOATING_NOTIFICATION_AS_READ: 'floatingNotificationMarkAsRead',
				REQUEST_FLOATING_NOTIFICATIONS: 'floatingNotificationsRequestNotifications',
				REFRESH_EMAIL_PROPERTIES: 'refreshEmailProperties',
				PASSWORD_CHANGED: 'passwordChanged',
				SEND_SIGNUP_EMAIL: 'sendSignupEmail',
				FAVORITE_PIN_ACTOR: 'favoritePinActor',
				FAVORITE_UNPIN_ACTOR: 'favoriteUnpinActor',
				FAVORITE_SET_PINNED_ACTOR_EMAIL_NOTIFICATION: 'favoriteSetPinnedActorEmailNotification',
				FAVORITE_SET_PINNED_ACTOR_SMS_NOTIFICATION: 'favoriteSetPinnedActorSMSNotification',
				FAVORITE_PIN_ALBUM: 'favoritePinAlbum',
				FAVORITE_UNPIN_ALBUM: 'favoriteUnpinAlbum',
				FAVORITE_PIN_SEDCARDS: 'favoritePinSedcards',
				FAVORITE_PIN_PICTURE: 'favoritePinPicture',
				FAVORITE_UNPIN_PICTURE: 'favoriteUnpinPicture',
				FAVORITE_REQUEST_ACTORS: 'favoriteRequestActors',
				PING: 'ping',
				REMOVE_STATUS_BAR: 'removeStatusBar',
			},

			Incoming: {
				SESSION_ACKNOWLEDGE: 'ackSession',
				SESSION_EXPIRED: 'sessionExpired',
				MESSAGE_PRICE: 'messagePrice',
				CHANNELS: 'channels',
				CHANNEL: 'channel',
				ALL_CHANNELS_SEEN: 'allChannelsSeen',
				CAN_ONECLICK_RESULT: 'canOneClickResult',
				CHARGE_ONECLICK_RESULT: 'chargeOneClickResult',
				DATA_PROTECTION: 'dataProtection',
				FAVORITE_ACTOR_PINNED: 'FavoriteActorPinned',
				FAVORITE_ACTOR_UNPINNED: 'FavoriteActorUnpinned',
				FAVORITE_PICTURE_PINNED: 'FavoritePicturePinned',
				FAVORITE_PICTURE_UNPINNED: 'FavoritePictureUnpinned',
				FAVORITE_ALBUM_PINNED: 'FavoriteAlbumPinned',
				FAVORITE_ALBUM_UNPINNED: 'FavoriteAlbumUnpinned',
				FAVORITE_SEDCARDS_ALBUM_PINNED: 'FavoriteSedcardsAlbumPinned',
				FAVORITE_SEDCARDS_ALBUM_UNPINNED: 'FavoriteSedcardsAlbumUnpinned',
				FAVORITE_ACTORS: 'FavoriteActors',
				GUEST_BALANCE: 'guestBalance',
				GUEST_VOUCHERS: 'guestVouchers',
				NAVBAR_NOTIFICATIONS: 'navbarNotifications',
				FLOATING_NOTIFICATIONS: 'floatingNotifications',
				ACTOR_ONLINE: 'actorOnline',
				ACTOR_OFFLINE: 'actorOffline',
				ACTOR_SETTINGS: 'actorSettings',
				AVS_REVOKED: 'avsRevoked',
				AVS_SET: 'avsSet',
				AVS_PENDING: 'avsPending',
				AVS_REJECTED: 'avsRejected',
				GUEST_LOCKED: 'guestLocked',
				CHANNEL_ARCHIVED: 'channelArchived',
				VIP_ABO_UPDATE: 'vipAboUpdate',
				VXTV_ABO_UPDATE: 'vxtvAboUpdate',
				VOICECALL_START: 'voicecallStart',
				VOICECALL_STOP: 'voicecallStop',
				WELCOME_BONUS_REDEEMED: 'welcomeBonusRedeemed',
				FREE_SHOW_START: 'freeShowStart',
				FREE_SHOW_STOP: 'freeShowStop',
				PONG: 'pong',
				PAGE_RELOAD: 'pageReload',
				ON_GUEST_EMAIL_VERIFIED: 'onGuestEmailVerified',
				MESSENGER_BOUGHT_GIFTS_UPDATE: 'messengerBoughtGiftsUpdate',
				FREE_CHAT_DURATION_CHANGED: 'freeChatDurationChanged',
				CLASH_OF_CAMS_VOTING: 'clashOfCamsVoting',
				LIVE_REACTION: 'liveReaction',
				SERVICE0900_STATUS_CHANGED: 'service0900StatusChanged',
				MESSENGER_CONTENT_CONTENT_CHANGE: 'messengerContentChange',
				PRIVATE_TICKET_SHOW_INVITATION: 'privateTicketShowInvitation',
				CHAT_END: 'chatEnd',
				LOYALTY_POINTS_CHANGED: 'loyaltyPointsChanged',
				BONUS_CODE_REDEEMED: 'bonusCodeRedeemed',
				PERKS_CHANGED: 'perksChanged',
				SEND_SIGNUP_EMAIL_RESULT: 'sendSignupEmailResult',
				MESSENGER_MESSAGE: 'messengerMessage',
				UBER_RAFFLE_RESULT: 'uberRaffleResult',
			},

			MessageTypes: {
				NEW_GIFT: 'new_gift',
			},
		},
	},

	ActorSearch: {
		DEFAULT_CATEGORY: 3,

		SearchTypes: {
			SEARCH_TYPE_DEFAULT: 'default',
			SEARCH_TYPE_CUSTOM: 'custom',
			SEARCH_TYPE_LOCATION: 'location',
			SEARCH_TYPE_NEW_GIRLS: 'newGirls',
		},
		SortTypes: {
			SEARCH_SORT_TYPE_RANK: 'rank',
			SEARCH_SORT_TYPE_DISTANCE: 'distance',
		},
	},

	ActorGender: {
		MALE: 'M',
		FEMALE: 'F',
	},

	// Matching src/VXBase/Api/Actor/EnumActorGenderType.php
	ActorGenderType: {
		FEMALE: 'F',
		MALE: 'M',
		COUPLE_FM: 'FM',
		COUPLE_FF: 'FF',
		TRANSSEXUAL: 'S',
	},

	AvsStatus: {
		PENDING: 'pending',
		REJECTED: 'rejected',
		ACCEPTED: 'accepted',
		UNKNOWN: 'unknown',
	},

	Browsers: {
		Name: {
			CHROME: 'Chrome',
			EDGE: 'Microsoft Edge',
			IE: 'IE',
			SAFARI: 'Safari',
		},
		OS: {
			IOS: 'iOS',
		},
	},

	Breadcrumb: {
		ACTOR_PROFILE_OVERVIEW: 'ActorProfileOverview',
		ACTOR_PROFILE_ABOUT: 'ActorProfileAbout',
		ACTOR_PROFILE_VIDEO_DETAILS: 'ActorProfileVideoDetails',
		ACTOR_PROFILE_LIVE_SHOW: 'ActorProfileLiveShow',
		ACTOR_PROFILE_VIDEOS_OVERVIEW: 'ActorProfileVideosOverview',
		ACTOR_PROFILE_VIDEOS_CLASSIC: 'ActorProfileVideosClassic',
		ACTOR_PROFILE_TOP_CAMGIRLS: 'ActorProfileTopCamgirls',
		CAMS: 'Cams',
		VIDEOS: 'Videos',
		VIDEOS_INDEX: 'VideosIndex',
		MYVISITX_SPINWHEEL: 'MyVisitXSpinwheel',
		MYVISITX_FAVORITES_OVERVIEW: 'MyVisitXFavoritesOverview',
		MYVISITX_FAVORITES_VIDEOS: 'MyVisitXFavoritesVideos',
		MYVISITX_MESSENGER: 'MyVisitXMessenger',
		MYVISITX_MEDIATHEK_VIDEOS_SHOP: 'MyVisitXMediathekVideos',
		MYVISITX_MEDIATHEK_VIDEOS_PINNED: 'MyVisitXMediathekVideosPinned',
		MYVISITX_MEDIATHEK_VIDEOS_PLAYLIST: 'MyVisitXMediathekVideosPlaylist',
		MYVISITX_MEDIATHEK_VIDEOS_ARCHIVE: 'MyVisitXMediathekVideosArchive',
		MYVISITX_MEDIATHEK_VIDEOS_FEED: 'MyVisitXMediathekVideosFeed',
		MYVISITX_MEDIATHEK_VIDEOS_MESSENGER: 'MyVisitXMediathekVideosMessenger',
		MYVISITX_MEDIATHEK_VIDEOS_CLIPS: 'MyVisitXMediathekVideosClips',
		MYVISITX_MEDIATHEK_PHOTOS_SHOP: 'MyVisitXMediathekPhotos',
		MYVISITX_MEDIATHEK_PHOTOS_PINNED: 'MyVisitXMediathekPhotosPinned',
		MYVISITX_MEDIATHEK_PHOTOS_ARCHIVE: 'MyVisitXMediathekPhotosArchive',
		MYVISITX_MEDIATHEK_PHOTOS_FEED: 'MyVisitXMediathekPhotosFeed',
		MYVISITX_MEDIATHEK_PHOTOS_MESSENGER: 'MyVisitXMediathekPhotosMessenger',
		MYVISITX_MEDIATHEK_AUDIO: 'MyVisitXMediathekAudio',
		MYVISITX_ACHIEVEMENT: 'MyVisitXAchievement',
		TOP_CAMS: 'TopCams',
		TOP_CAMS_BEST_CHATS: 'TopCamsBestChats',
		TOP_CAMS_TOP_100: 'TopCamsTop100',
		TOP_CAMS_TOP_FAVORITES: 'TopCamsTopFavorites',
		TOP_CAMS_TOP_VIDEOCALL: 'TopCamsTopVideocall',
		BLOG_OVERVIEW: 'BlogOverview',
		MAGAZINE_CONTESTS_OVERVIEW: 'MagazineContestsOverview',
		MAGAZINE_CONTESTS_DETAILS: 'MagazineContestsDetails',
		DAILY_BONUS: 'DailyBonus',
	},
	Relations: {
		Subjects: {
			GUEST: 1,
		},
		Predicates: {
			HAS_SEEN: 1,
			HAS_SUBSCRIBED: 2,
		},
		Objects: {
			STORY: 1,
			TEASER: 2,
			NEWSLETTER: 3,
			MODALBOX: 5,
			SPINWHEEL: 8,
			ACHIEVEMENT: 9,
			PROFILE_ONBOARDING: 10,
			SPINWHEEL_ACHIEVMENT: 11,
			KICK_IT_2026_CARDS_COLLECTED: 12,
			TV_SERIEN_MENU_TOOLTIP: 13,
		},
	},

	Blog: {
		CategoryAlias: {
			EVENT: 'events',
			ACTIONS: 'actions',
			NEWS: 'news',
			INTERVIEWS: 'interviews',
			LATEST: 'latest',
		},
		CategoryIds: {
			ALLGEMEIN: 1,
			EVENT: 38,
			PREMIUM_TV: 40,
			ACTIONS: 43,
			NEWS: 45,
			INTERVIEWS: 46,
			FEATURED: 506,
		},
		PageSize: {
			default: 3,
			archives: 9,
		},
	},

	ChannelFilterTypes: {
		NEWEST: 'newest',
		ARCHIVED: 'archived',
		UNREAD: 'unread',
		BLOCKED: 'blocked',
	},

	TicketCreationType: {
		CHAT_TICKET: 'C',
	},

	ContestSubTypes: {
		NOT_VOTED: 'notvoted',
		OVERVIEW: 'overview',
		TOP_10: 'top10',
		VOTED: 'voted',
		ACTOR: 'actor',
	},

	ContestLastContestsSubTypes: {
		OVERVIEW: 'overview',
		VIDEO_CONTESTS: 'videoContests',
		PHOTO_CONTESTS: 'photoContests',
	},

	// Same as ContestsApi::MAX_VOTES_PER_CONTEST
	MaxVotesPerContest: 5,

	/**
	 * @see EnumEventTypes
	 */
	ConversionEventTypes: {
		BUY_IMAGE_ALBUM_OPENED: 'buyImageAlbumOpened',
		CLEAR: 'clear',
		PAGE_LOAD: 'pageLoad',
		VIDEO_PREVIEW_ENDED: 'videoPreviewEnded',
	},

	/**
	 * @see EnumGuestInfoTypes
	 */
	ConversionGuestInfoTypes: {
		GUEST_ALREADY_SIGNED_UP: 'GUEST_ALREADY_SIGNED_UP',
	},

	/**
	 * @see EnumIncentiveRegions
	 */
	ConversionIncentiveRegions: {
		EXIT_INTENT: 'exitIntent',
		OVERLAY_FULL_SIZE: 'overlayFullSize',
		OVERLAY: 'overlay',
		SIDE_LEFT: 'sideLeft',
		SIDE_RIGHT: 'sideRight',
		VIDEO_PLAYER: 'videoPlayer',
		IN_PAGE: 'inPage',
	},

	/**
	 * @see EnumIncentiveTypes
	 */
	ConversionIncentiveTypes: {
		BALANCE_REFILL_COUPON: 'BALANCE_REFILL_COUPON',
		EVENT_EASTER_EGG_SEARCH: 'EVENT_EASTER_EGG_SEARCH',
		EXIT_INTENT_DEFAULT: 'EXIT_INTENT_DEFAULT',
		IMAGE_ALBUM_BUY: 'IMAGE_ALBUM_BUY',
		SALE_BONUS_COUNTER: 'SALE_BONUS_COUNTER',
		SIDE_SIGNUP_FREE_VIDEO: 'SIDE_SIGNUP_FREE_VIDEO',
		VIDEO_PREVIEW_AVS: 'VIDEO_PREVIEW_AVS',
		VIDEO_PREVIEW_BUY: 'VIDEO_PREVIEW_BUY',
		VIDEO_PREVIEW_LOGIN: 'VIDEO_PREVIEW_LOGIN',
		VIDEO_PREVIEW_PAYMENT: 'VIDEO_PREVIEW_PAYMENT',
		VIDEO_PREVIEW_SALE: 'VIDEO_PREVIEW_SALE',
		VIDEO_PREVIEW_SIGNUP: 'VIDEO_PREVIEW_SIGNUP',
		VIDEO_PREVIEW_VIP: 'VIDEO_PREVIEW_VIP',
		LUCY_CAT_VIDEO: 'LUCY_CAT_VIDEO',
	},

	CookieNames: {
		COOKIEBANNER_ACCEPTED: 'cookiebanner-accepted',
		COOKIES_BLOCKED: 'cookiesBlocked',
		FORCED_AVS: 'favs',
		HAS_USER_SEEN_WELCOME_BANNER: 'huswb',
		STATUS_BAR_CANCELLATION_OFFER: 'sbcanoff',
		STATUS_BAR_EMAIL_VERIFIED: 'sbemav',
		STATUS_BAR_MONTHLY_BONUS: 'sbmbns',
		STATUS_BAR_NOAVS: 'sbnavs',
		TEASER_SHOW: 'tes',
		WM_ID: 'w',
		WM_SUBREF: 'ws',
		WM_TOKEN: 'wt',
	},

	CookieCategories: {
		NECESSARY: vxcookies.CookieCategories.NECESSARY,
		FUNCTIONAL: vxcookies.CookieCategories.FUNCTIONAL,
		ANALYTICS: vxcookies.CookieCategories.ANALYTICS,
	},

	CookieSameSiteAttributes: {
		LAX: vxcookies.CookieSameSiteAttributes.LAX,
	},

	Currency: {
		EUR: 'EUR',
		CHF: 'CHF',
		VOC: 'Credits',
		VOU: 'Voucher',
		VXC: 'VXC',
	},

	CurrencySymbol: {
		EUR: '€',
		CHF: 'CHF',
		VOC: 'Credits',
		VOU: 'Voucher',
		VXC: 'VXC',
	},

	EntryPage: {
		Ids: {
			ADWORDS_STARTPAGE: 5,
		},
	},

	FEEDBACK_RATINGS: {
		BAD: 'BAD',
		GREAT: 'GREAT',
	},

	Guest: {
		Restrictions: {
			NEED_LOGIN: 'needLogin',
			NEED_AVS: 'needAgeCheck',
			NEED_ABO: 'needAbo',
			NEED_PURCHASE: 'needPurchase',
		},
		Perks: {
			HIGHLIGHT_COMMENTS: 'HIGHLIGHT_COMMENTS',
			HIGHLIGHT_LIKES: 'HIGHLIGHT_LIKES',
			VIDEO_DISCOUNT: 'VIDEO_DISCOUNT',
		},
	},

	LocalItemNames: {
		GLOBAL_SEARCH_REQUESTS: 'globalSearchLastRequests',
		VIDEO_PLAYER_VOLUME: 'playerVolume',
	},

	TIMELINE_NAVIGATION: {
		BLOCKS: {
			FAVORITE: 'Favorite',
			TOP: 'TOP',
			CAMSHOWS: 'CAMSHOWS',
			DAILYBONUS: 'Dailybonus',
			VIP30: 'VIP30',
			FEED: 'Feed',
			TRENDS: 'Trends',
			VIDEOSTATION: 'Videostation',
			NEW: 'New',
			CONTESTS: 'Contests',
			WELCOMECLIPS: 'WelcomeClips',
			CATEGORIES: 'Categories',
			BLOG: 'Blog',
			TV: 'TV',
		},
	},

	Grid2: {
		BREAKPOINTS: {
			XS: 'xs',
			SM: 'sm',
			MD: 'md',
			LG: 'lg',
			XL: 'xl',
		},

		BREAKPOINTS_SMALL_TO_LARGE: ['xs', 'sm', 'md', 'lg', 'xl'],

		BREAKPOINT_MIN_WIDTHS: {
			sm: 768,
			md: 992,
			lg: 1200,
			xl: 1368,
		},

		TilePadding: {
			TINY: 'TINY',
			SMALL: 'SMALL',
			NORMAL: 'NORMAL',
			LARGE: 'LARGE',
		},

		Footer: {
			Label: {
				Styles: {
					TITLE: 'TITLE',
					SUBTITLE: 'SUBTITLE',
					ACTOR_NAME: 'ACTOR_NAME',
				},
				FontSizeScaling: {
					NONE: 'NONE',
					THREE_QUARTERS: 'THREE_QUARTERS',
					HALF: 'HALF',
					BIG: 'BIG',
				},
			},
		},

		TextBadge: {
			Styles: {
				DEFAULT: 'DEFAULT',
				SUCCESS: 'SUCCESS',
				HIGHLIGHT: 'HIGHLIGHT',
				SPECIAL: 'SPECIAL',
				GOLD: 'GOLD',
				SHAPE: 'SHAPE',
				TRANSPARENT: 'TRANSPARENT',
			},

			FontColors: {
				WHITE: 'WHITE',
				BLACK: 'BLACK',
				DARK_GREY: 'DARK_GREY',
				HIGHLIGHT: 'HIGHLIGHT',
				TRANSPARENT: 'TRANSPARENT',
			},
		},

		ModelAvatar: {
			Size: {
				SM: 'sm',
				MD: 'md',
				LG: 'lg',
			},
		},

		Ribbons: {
			TRENDING: 'TRENDING',
		},
	},

	HistoryStateKeys: {
		INITIAL_PAGE: 'initialPage',
		RESTORE_SCROLL_POSITION: 'restoreScrollPosition',
	},

	Interviews: {
		IMAGE_SIZE_720: 'h720',
		DURATION_MIN: 'min',
		DURATION_SEC: 'sec',
	},

	HttpMethods: {
		GET: 'GET',
		HEAD: 'HEAD',
		POST: 'POST',
		PUT: 'PUT',
	},

	Languages: {
		DE: 'de',
		EN: 'en',
		NL: 'nl',
		ES: 'es',
	},

	MediaTypes: {
		PHOTO_ALBUM: 'photo_album',
		VIDEO: 'video',
	},

	MinimumBalanceRequiredForChat: 0.5,

	PromoCodes: {
		BONUS_TILE: 'NEU50WELCOME',
		CONVERSION_CHAT_TRIAL: 'CONVCHATTRIAL',
	},

	// see MailSubscriptionEnum
	NewsletterTypes: {
		VRPORN: 2048,
	},

	Placeholders: {
		Avatar: {
			FEMALE: 'https://vx.vxcdn.org/public/vxteaser/placeholder/placeholder_female.jpg',
		},
	},

	Ratings: {
		AlbumDislike: 1,
		AlbumLike: 5,
	},

	RegExp: {
		EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-z\-0-9]+\.)+[a-z]{2,}))$/i,
	},

	RewardTypes: {
		BONUSCODE: 'BONUSCODE',
		BONUSCODE_VIP: 'bonuscode_vip',
		BONUS: 'bonus',
		ONTOP: 'ontop',
		ONTOP_FLAT: 'ontopflat',
		VIDEO: 'video',
		LIVESHOW: 'liveshow',
		TICKETSHOW: 'ticketshow',
		VIP_BONUS: 'vipBonus',
		CHAT_ROSES: 'chatRoses',
		MERCH: 'merch',
		MESSENGER_GIFT: 'messengerGift',
		PHOTO_ALBUM: 'photoAlbum',
		VIDEO_VOUCHER: 'videoVoucher',
		FREE_SPIN: 'freeSpin',
		FREE_SPINS: 'freeSpins',
		FREE_MESSAGES: 'freeMessages',
		BLANK: 'blank',
		ACHIEVEMENT_UNLOCK: 'achievementUnlock',
		CARD_PACK: 'cardPack',
	},

	CalendarItemType: {
		VIDEO: 'video',
		GALLERY: 'photo_album',
		COUPON: 'coupon',
		MESSENGER_GIFTS: 'messengerGifts',
		MERCHANDISE_COUPON: 'merchandise',
	},

	ScrollAnchors: {
		ANCHOR: 'anchor',
	},

	Search: {
		PATTERNS: {
			ASMR: 'asmr-girls',
		},
	},

	SpecialEvents: {
		NEWSLETTER_UNSUBSCRIBE: 'newsletter_unsubscribe',
		SPECIAL_VR_PORN: 'vr_porn',
		SPECIAL_KICK_IT_2026: 'kick_it_2026',
		SPECIAL_WIESN_SHOOTING: 'wiesn_shooting',
		SPECIAL_WET_AND_WILD: 'wet_and_wild',
		SPECIAL_WIESN_BUDE: 'wiesn_bude',
		SPECIAL_HALLOWEEN: 'halloween',
		SPECIAL_CUM_ON: 'cum_on',
	},

	VXGame: {
		RewardTypes: {
			BONUS_CODE: 'BONUS_CODE',
			COINS: 'COINS',
			MESSENGER_GIFT: 'MESSENGER_GIFT',
			SPINS: 'SPINS',
			VIDEO: 'VIDEO',
			VIDEO_VOUCHER: 'VIDEO_VOUCHER',
		},

		GameStatus: {
			LIVE: 'LIVE',
			NOT_LIVE: 'NOT_LIVE',
		},
	},

	SpecialEventsBanner: {
		HALLOWEEN: 559,
		HALLOWEEN_MOBILE: 560,
	},

	SurveyTypes: {
		CHAT_EXIT: 'SURVEY_CHAT_EXIT',
		FEEDBACK: 'SURVEY_FEEDBACK',
	},

	Teaser: {
		AVS: 'avs',
		PAYMENT: 'payment',
		PROMOCODE: 'promocode',
		VOICECALL: 'voicecall',
		SIGNUP: 'signup',
		VIDEO: 'video',
		MODALBOX: 'modalbox',
	},

	/**
	 * @see EnumTestId
	 */
	TestId: {
		RECOMMENDED_VIDEO_FILTER_TEST: 50,
		VXONE_EMAIL_BOUNCED_RESET_TEST: 64,
	},

	TestGroup: {},

	/**
	 * @see EnumTestId
	 */

	TileGrid: {
		CONTESTS_ACTIVE_CONTESTS: 'contestsActiveContests',
		CONTESTS_NEXT_CONTESTS: 'contestsNextContests',
		CONTESTS_LAST_CONTESTS: 'contestsLastContests',
		FAVORITE_ACTORS: 'favoriteActors',
		FAVORITE_VIDEOS: 'favoriteVideos',
		MY_VIDEOCHATS: 'myVideoChats',
		RECOMMENDATIONS_BEST_CHATS: 'recommendationsBestChats',
		TV_ALL_SERIES: 'tvAllSeries',
		TV_ALL_VIDEOS: 'tvAllVideos',
		TV_EPISODES: 'tvEpisodes',
		TV_POSTS: 'tvPosts',
		TV_LATEST_SERIES: 'tvLatestSeries',
		TV_LATEST_SERIES_VIDEOS: 'tvLatestSeriesVideos',
		TV_LATEST_VIDEOS: 'tvLatestVideos',
		TV_RECOMMENDED_VIDEOS: 'tvRecommendedVideos',
		TV_RECOMMENDED_VIDEOS_ALL: 'tvRecommendedVideosAll',
		TV_SHOWS: 'tvShows',
	},

	TileGridModes: {
		GRID: 'TILEGRID_MODE_GRID',
		LIST: 'TILEGRID_MODE_LIST',
	},

	TileGridSorts: {
		DURATION: 'duration',
		FREE: 'free',
		PRICE: 'price',
		RATING: 'rating',
		RELEASED: 'released',
		SOLD: 'sold',
	},

	TileGridBreakpoints: {
		FiveCols: 1199,
		FourCols: 991,
		ThreeCols: 767,
	},

	TimeLimits: {
		LIVE_PREVIEW: 5,
		LIVE_PREVIEW_VIP: 20,

		Types: {
			TEXT: 'text',
			VIDEO: 'video',
		},
	},

	VXMobile: {
		ActorProfilePages: {
			OVERVIEW: 'ACTOR_PROFILE_OVERVIEW',
			VIDEOS: 'ACTOR_PROFILE_VIDEOS',
			LIVE_SHOW: 'ACTOR_PROFILE_LIVE_SHOW',
		},

		Menus: {
			NAVI: 'MENU_NAVI',
			SEARCH: 'MENU_SEARCH',
			CAM_FILTER: 'MENU_CAM_FILTER',
			CATEGORY_FILTER: 'MENU_CATEGORY_FILTER',
			MY_VISIT_X: 'MENU_MY_VISIT_X',
			NOTIFICATIONS: 'MENU_NOTIFICATIONS',
		},

		FavoriteActorsPerPage: 10,
		HiddenNotificationTypes: [6, 7, 13, 14, 15, 22],
		MinSearchPatternLength: 3,
		RecommendationsPerGrid: 8,
		RecommendationsPerSlider: 5,
	},

	VXPay: {
		Environments: {
			VXONE_LP: 'vxonelp',
		},
		Flows: {
			AVS: 'avs',
			LOGIN: 'login',
			MONEY_CHARGE: 'moneycharge',
			TRIAL_VIP_ABO: 'trialvipabo',
			VIP_ABO: 'vipabo',
			VXTV_ABO: 'vxtvabo',
		},
	},

	Vxql: {
		Videos: {
			SortOrders: {
				NEWEST: 'newest',
				MOST_EXPENSIVE: 'mostExpensive',
				CHEAPEST: 'cheapest',
				LONGEST: 'longest',
				SHORTEST: 'shortest',
				BEST_SELLING: 'bestSelling',
				TOP_RATED: 'topRated',
				TOP_TRENDING: 'topTrending',
				REDUCED_RANDOM: 'reducedRandom',
				BEST: 'best',
			},

			ActingGroups: {
				FEMALES: 'females',
				MALES: 'males',
				COUPLES: 'couples',
				LESBIANS: 'lesbians',
				GAYS: 'gays',
			},
		},
		Pictures: {
			Sort: {
				NEWEST: 'newest',
			},
		},
		Search: {
			Order: {
				NEWEST: 'newest',
				PURCHASES: 'purchases',
				BEST: 'best',
				LONGEST: 'longest',
				RATING: 'rating',
				EXPENSIVE: 'expensive',
				CHEAP: 'cheap',
			},
		},

		Collection: {
			Order: {
				ALPHABETICAL: 'alphabetical',
				VIEWS: 'views',
			},
		},

		MediathekVideos: {
			ContentGroups: {
				ANSAGEN: 'ansagen',
				SERIE: 'serie',
				SPOT: 'spot',
				TALK: 'talk',
				TEASER: 'teaser',
				TRAILER: 'trailer',
				LOGO: 'logo',
			},
		},
		Actors: {
			Order: {
				ONLINE_RANKING: 'online_ranking',
				RANKING: 'ranking',
				DATE: 'date',
				GUEST_PREFERENCES: 'guest_preferences',
				DISTANCE: 'distance',
			},
			Presets: {
				NEW_GIRLS: 'newGirls',
			},
		},
		MyVisitXMediathekSort: {
			NEWEST: 'newest',
			OLDEST: 'oldest',
			LONGEST: 'longest',
			SHORTEST: 'shortest',
		},
	},

	Websocket: {
		ErrorCodes: {
			PROTOCOL_ERROR: 1002,
			PONG_IS_MISSING: 4000,
		},

		ErrorTypes: {
			CONNECTION_CLOSED: 'WEBSOCKET_ERROR_CONNECTION_CLOSED',
			PONG_IS_MISSING: 'WEBSOCKET_ERROR_PONG_IS_MISSING',
		},

		Types: {
			BOOMER: 'Boomer',
		},
	},

	WebPush: {
		Permissions: {
			GRANTED: 'granted',
			DENIED: 'denied',
			DEFAULT: 'default',
		},
	},

	Video: {
		Categories: {
			ALL: 'VideosAll',
			NEWEST: 'VideosNew',
			TRENDING: 'VideosTrending',
			FREE_WEEKLY: 'VideosFreeClips',
			ON_SALE: 'VideosOnSale',
		},
		CategoriesV2: {
			ALL_VIDEOS: 'allVideos',
			DISCOUNTED_VIDEOS: 'discountedVideos',
			TRENDING_VIDEOS: 'trendingVideos',
			FREE_VIDEOS: 'freeVideos',
			VIP_30_VIDEOS: 'vip30Videos',
			NEW_VIDEOS: 'newVideos',
			BOUGHT_VIDEOS: 'boughtVideos',
		},
		Jumbotron: {
			TYPE_HOMEPAGE: 'homepage',
			TYPE_VIDEO_STATION: 'videoStation',
		},
		Filter: {
			PREMIUM: 'premium',
			BOUGHT: 'bought',
			VIP: 'vip',
			FREE: 'free',
			ORIGINAL: 'original',
			DISCOUNT: 'discount',
			TRENDING: 'trending',
			CLASSIC: 'classic',
			CONTEST: 'contest',
		},
	},

	DailyBonuses: {
		offers: {
			VIP: 'VipOneDay',
			VIDEO: 'video',
			PHOTO_ALBUM: 'photo_album',
			TOP_UP_PERCENT: 'TopUpPercent',
			TOP_UP_FLAT: 'TopUpFlat',
			MERCHANDISE: 'Merchandise',
			MESSENGER_GIFT: 'MessengerGift',
			VIDEO_VOUCHER: 'VideoVoucher',
		},
		timerConsts: {
			DAY_DATE_HOURS: 23, // in the day 24 hours but on the clock we will never see 24:00 it should be 00:00. Therefore, we use 23 hours and 60 minutes
			DAY_DATE_MINUTES: 59,
			DAY_DATE_SECONDS: 59,
		},
		signature: {
			OFFER_VIP: 'LeahObscure & AlissaNoir',
			TOP_UP_PERCENT: '', // no model name nows
			TOP_UP_FLAT: 'MimiSweet',
			MESSENGER_GIFT: 'Lilly-Lil',
			VIDEO_VOUCHER: 'KiraKane',
		},
		offerBgs: {
			VIP: '/assets/img/special_events/Dailybonus/backgrounds/365specials_img_onedayvip_leahobscure_alissanoir.jpg',
			TOP_UP_PERCENT: 'https://vx.vxcdn.org/public/vxevents/365calendar/backgrounds/365specials_img_vipbonus_jayjaypink.jpg',
			TOP_UP_FLAT: '/assets/img/special_events/Dailybonus/backgrounds/365specials_img_bonus_mimisweet.jpg',
			MERCHANDISE: '/assets/img/special_events/Dailybonus/backgrounds/365specials_img_merchshop.jpg',
			MESSENGER_GIFT: '/assets/img/special_events/Dailybonus/backgrounds/365specials_img_messengergift_lillylil.jpg',
			VIDEO_VOUCHER: '/assets/img/special_events/Dailybonus/backgrounds/365specials_img_videovoucher_kirakane.png',
		},
	},

	VoucherTypes: {
		TYPE_VIDEO: 1,
		TYPE_VIDEOCHAT: 2,
		TYPE_CREDITS: 3,
		TYPE_PHOTO_ALBUM: 4,
		TYPE_MESSAGES: 5,
		TYPE_MESSENGER_GIFT: 6,
		TYPE_LIVE_SHOW: 7,
		TYPE_PRIVATE_SHOW: 8,
		TYPE_BONUS_CODE: 9,
		TYPE_SPINS: 10,
	},

	BenefitsType: {
		BONUS: 'BenefitBonus',
		BONUS_COINS: 'BenefitBonusCoins',
		BONUS_CREDIT: 'BenefitBonusCredits',
		VIP_ABO: 'BenefitVIPAbo',
		PREMIUM_ABO: 'BenefitPremiumAbo',
		ACTOR_ABO: 'BenefitActorAbo',
		FREE_MESSAGES: 'BenefitFreeMessages',
		FREE_MINUTES: 'BenefitFreeMinutes',
		MEDIA: 'BenefitMedia',
		VOUCHER_VIDEO: 'BenefitVoucherVideo',
		VOUCHER_PHOTO: 'BenefitVoucherPhoto',
		LIVE_SHOW: 'BenefitLiveShow',
		MESSENGER_GIFT: 'BenefitMessengerGifts',
	},

	VoucherTypeNames: {
		TYPE_VIDEO: 'videos',
		TYPE_VIDEOCHAT: 'chatSeconds',
		TYPE_PHOTO_ALBUM: 'galleries',
		TYPE_MESSAGES: 'messages',
	},

	SearchResults: {
		Categories: {
			actors: {
				name: 'actors',
				itemsPerPage: 30,
			},
			models: {
				name: 'models',
			},
			videos: {
				name: 'videos',
				itemsPerPage: 30,
			},
			asmr: {
				name: 'asmr',
				itemsPerPage: 3,
			},
			photos: {
				name: 'photos',
			},
			galleries: {
				name: 'galleries',
			},
			tv: {
				name: 'tv',
				itemsPerPage: 30,
			},
			mediathek: {
				name: 'mediathek',
			},
			blog: {
				name: 'blog',
				itemsPerPage: 15,
			},
		},
	},

	ChatRatings: {
		LAST_NINETY_DAYS: 'lastNinetyDays',
	},

	Pincall: {
		ErrorCodes: {
			INVALID_PHONE_NUMBER: 1,
			COUNTRY_NOT_ALLOWED: 2,
			INVALID_VERIFICATION_TYPE: 3,
			VERIFICATION_TIME_OUT: 4,
			PHONE_NUMBER_IN_BLACKLIST: 5,
			PHONE_NUMBER_NOT_UNIQUE: 6,
			INVALID_CODE: 8,
			ATTEMPT_LIMIT_REACHED: 9,
			UNKNOWN: 10,
		},

		VerificationTypes: {
			UNIQUE_NUMBER: 'uniqueNumber',
		},

		Languages: {
			DE: 'DE',
			EN: 'EN',
			ES: 'ES',
		},

		PinCallLength: {
			MOBILE: 6,
			FIXED: 5,
		},
	},
	MessengerContent: {
		BITMAP: 'Bitmap',
		VIDEO: 'Video',
		AUDIO: 'Audio',
	},
	VXMessenger: {
		Modes: {
			WEBTOKEN: 'webtoken',
			SERVER: 'server',
		},
		ChatTypes: {
			LIVECHAT: 'LIVECHAT',
			VOYEUR_CHAT: 'VOYEUR_CHAT',
			FREECHAT: 'FREECHAT',
			LIVEPREVIEW: 'LIVE_PREVIEW',
			VOYEUR_2S_CHAT: 'VOYEUR_PRIVATE_CHAT',
			VIDEOCALL: 'VIDEO_CALL',
			LIVESHOW: 'LIVESHOW',
		},
		// Type of the chat that just ended, reported by the chat server in the CEXIT payload and handed to the
		// onExit hook as its fourth argument. Mirrors EndChatType of cmd-control-client-lib.
		// LOBBY is the ticket show: the chat server opens a lobby chat for a running ticket show.
		EndChatTypes: {
			PREPARED: 'PREPARED',
			LOBBY: 'LOBBY',
			ADMIN: 'ADMIN',
			SINGLEC2C: 'SINGLEC2C',
			SINGLE: 'SINGLE',
			LIVE: 'LIVE',
			VOYEUR: 'VOYEUR',
			VOYEUR2S: 'VOYEUR2S',
			PREVIEW: 'PREVIEW',
			PREVIEW_VIP: 'PREVIEW_VIP',
			PREVIEW_SHORT: 'PREVIEW_SHORT',
			PREVIEW_VOUCHER: 'PREVIEW_VOUCHER',
			MOBILEVIDEOCALL: 'MOBILEVIDEOCALL',
		},
	},
	Headlines: {
		h1: 'h1',
		h2: 'h2',
		h3: 'h3',
		h4: 'h4',
	},

	Feed: {
		FeedType: {
			PROFILE: 'profile',
			MIXED: 'mixed',
			FAVORITE: 'favorite',
			STARTPAGE: 'startpage',
		},
		Types: {
			CLIP: 'CLIP',
			HOT_CLIP: 'HOT_CLIP',
			FP_HOT_CLIP: 'FP_HOT_CLIP',
			PHOTO_GALLERY: 'PHOTO_GALLERY',
			PHOTOS: 'PHOTOS',
			FP_PHOTO_GALLERY: 'FP_PHOTO_GALLERY',
			PROFILE_IMAGE: 'PROFILE_IMAGE',
			TEXT: 'TEXT',
			CONTEST: 'CP_PHOTO_CONTEST',
		},
		OverlayTypes: {
			ALL: 'all',
			COMMENTS: 'comments',
		},
		Filter: {
			BOUGHT: 'BOUGHT',
			TEXT_POSTS: 'TEXT_POSTS',
			PHOTOS_POSTS: 'PHOTOS_POSTS',
			CLIP_POSTS: 'CLIP_POSTS',
			LIKED: 'LIKED',
			COMMENTED: 'COMMENTED',
		},
		Mode: {
			STARTPAGE: 'STARTPAGE',
			MIXED: 'MIXED',
			MODEL: 'MODEL',
			USER_RECOMMENDATIONS: 'USER_RECOMMENDATIONS',
		},
		Context: {
			MIXED_FEED: 'MIXED_FEED',
			PROFILE: 'PROFILE',
			UNKNOWN: 'UNKNOWN',
		},
		OnlineState: {
			ONLINE: 'ONLINE',
			MOMENTUM: 'MOMENTUM',
		},
	},
	ActorId: {
		LUCY_CAT: 5613624,
		LANA_GREY: 12135526,
		LEXY_ROXX: 3926584,
		LENI_FETISCH: 10327862,
		LIAENGEL: 10641720,
	},
	Legal: {
		Types: {
			PP: 'PP', // Privacy Policy VX
			GTC: 'GTC', // General Terms and Contidions VX
			IMP: 'IMP', // Imprint VX
			CN2257: 'CN2257', // Compliance Notice 2257
		},
	},
	Loader: {
		Types: {
			LOGO: 'logo',
			DOT: 'dot',
			CIRCLE: 'circle',
			NONE: 'none',
		},
	},
	Spinwheel: {
		Types: {
			default: 'default',
			goldrausch: 'goldrausch',
			kickspiel26: 'kickspiel-26',
		},
	},

	StatusBar: {
		Types: {
			BARTYPE_NOAVS: 'noavs',
			BARTYPE_AUTOMATIC_RECHARGE: 'automaticrecharge',
			BARTYPE_AVS_STATUS: 'avsstatus',
			BARTYPE_AVS_ACCEPTED: 'avsaccepted',
			BARTYPE_MAILNOTVERIFIED: 'mailnotverified',
			BARTYPE_MAILWELCOMELINK: 'mailwelcomelink',
			BARTYPE_WELCOMEBACK_USER: 'welcomebackuser',
			BARTYPE_ERROR: 'error',
			BARTYPE_CANCELATION_OFFER: 'cancelationoffer',
			BARTYPE_CANCELATION_OFFER_ERROR: 'cancelationoffererror',
			BARTYPE_MONTHLY_BONUS_PROCESSED_NOTIFICATION: 'monthlybonusnotif',
			BARTYPE_NOT_FOUND_REDIRECT: 'notfoundredirect',
		},
	},
	VideochatButtonTypes: {
		actorProfileVideochat: 'videochat',
		actorProfileVoyeurchat: 'voyeurchat',
		actorPlateVideochat: 'actorPlate',
		actorPlateExtendedVideochat: 'actorPlateExtendedVideochat',
		actorPlateExtendedLightVideochat: 'actorPlateExtendedLightVideochat',
		actorProfileLivePreview: 'livePreview',
		actorProfileLivePreviewMedium: 'livePreviewMedium',
		actorProfileLivePreviewSmall: 'livePreviewSmall',
		actorProfilePrivateVideoCall: 'privateVideoCall',
		actorProfilePrivateVideoCallSmall: 'actorProfilePrivateVideoCallSmall',
		chatExitButton: 'chatExitButton',
		videochatButton: 'videochatButton',
		videochatMessengerButton: 'videochatMessengerButton',
		actorTile: 'actorTile',
	},
	Mediathek: {
		MediaType: {
			VIDEO: 'VIDEO',
			PHOTO: 'PHOTO',
		},
		SourceType: {
			PURCHASED: 'PURCHASED',
			PINNED: 'PINNED',
			ARCHIVED: 'ARCHIVED',
		},
		OriginType: {
			SHOP: 'SHOP',
			CHATCLIP: 'CHATCLIP',
		},
	},
	Tooltip: {
		place: {
			Top: 'top',
			Right: 'right',
			Bottom: 'bottom',
			Left: 'left',
		},
	},
	TopCams: {
		Categories: {
			TOP_100: 'top_100',
			FAVORITES: 'top_favorites',
			BEST_CHATS: 'top_chats',
			VIDEOCALL: 'top_videocall',
			LENI_GIRLS: 'leni_girls',
			LEXY_GIRLS: 'lexy_girls',
			LUCY_GIRLS: 'lucy_girls',
			LANA_GIRLS: 'lana_girls',
			LIA_GIRLS: 'lia_girls',
		},
	},

	Uber: {
		Flow: {
			LIVECHAT: 'LIVECHAT',
			MESSAGING: 'MESSAGING',
		},
	},
};

export default Constants;
